import { render } from "./UserComments.vue?vue&type=template&id=549c5476&scoped=true"
import script from "./UserComments.vue?vue&type=script&lang=js"
export * from "./UserComments.vue?vue&type=script&lang=js"

import "./UserComments.vue?vue&type=style&index=0&id=549c5476&scoped=true&lang=css"

import exportComponent from "/vercel/path0/Source Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-549c5476"]])

export default __exports__